import { InvoiceFileState } from 'store/invoices/types';

type FileValidityCheck = {
    fileId?: string;
    fileName?: string;
    state?: InvoiceFileState;
};

export const isValidInvoiceFile = (file: FileValidityCheck): boolean => {
    return Boolean(file.fileName) && file.state === InvoiceFileState.PRESENT;
};
